import React, { useState } from "react";
import { useNavigate } from "react-router-dom";


export default function PasswordCheckViewMore({ show, setShow }) {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const correctPassword = "1122@3344";
    const handleSubmit = (e) => {
        e.preventDefault();
        if (password === correctPassword) {
            setError("");
            navigate(`/agent/dashboard/matches/${show?.matchId}/current_bets`, { state: { correctPassword } });
        } else {
            setError("Invalid password. Please try again.");
        }
    };
    return (
        <>
        <div
            id="detailaModal"
            className="sitemoadal modal fade show"
            aria-modal="true"
            role="dialog"
            style={{ display: "block" }} >
            <div
                className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5
                            id="exampleModalLabel"
                            className="modal-title" >
                            Confirm Password
                        </h5>
                        <button
                            type="button"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => {
                                setShow(null);
                            }}
                            className="btn-close"
                        />
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body d-flex align-items-center w-100" style={{ height: '120px' }}>
                            <div className="w-100">
                                <input
                                    type="password"
                                    className="w-full w-100 p-2 border rounded-md mb-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    placeholder="Enter password"
                                    value={password}
                                    style={{ height: '45px', fontSize: '20px' }}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                {error && <p className="text-red text-sm mb-2" style={{ color: 'red' }}>{error}</p>}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className=" d-flex" style={{gap : '5px'}}>
                            <button
                                type="submit"
                                // style={{width : '50%'}}
                                className="btn btn-primary" >
                                Submit
                            </button>
                            <button
                                onClick={() => {
                                    setShow(null);
                                }}
                                // style={{width : '50%'}}
                                type="button"
                                className="btn btn-secondary">
                                <span>Cancel</span>
                            </button>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show"></div>
        </>

    );
}
